import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  CardWrapper,
  VisiblePart,
  CardHead,
  ArrowWrapper,
  ButtonsWrapper,
  Details,
  Tags,
} from '@layout/AttendeeDashboard';
import { personType } from '@reducers/conference';
import { H2, Attendees, Chip as Tag } from '@atoms';
import { TranscriptLinks, ToggleArrow } from '@molecules';

export class TranscriptCard extends PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    date: PropTypes.string,
    status: PropTypes.string,
    people: PropTypes.arrayOf(personType),
    isCloudSearchResults: PropTypes.bool,
  };

  state = {
    expanded: false,
  };

  renderTag = (tag, key) => <Tag key={key}>{tag}</Tag>;

  toggleSummary = () => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  };

  render() {
    const {
      id,
      title,
      date,
      status,
      isHumanTranscriptionAvailable,
      isAITranscriptionAvailable,
      people,
      countries,
      tags,
      isCloudSearchResults,
    } = this.props;
    const { expanded } = this.state;

    return (
      <CardWrapper>
        <VisiblePart
          onClick={() => {
            !isCloudSearchResults && this.toggleSummary();
          }}
        >
          <CardHead>
            <H2>{title}</H2>
            {!isCloudSearchResults && <div>{moment(date).format('MM/DD/YYYY')}</div>}
          </CardHead>
          <ButtonsWrapper>
            <div>
              <TranscriptLinks
                id={id}
                status={isCloudSearchResults ? 'complete' : status}
                isHumanTranscriptionAvailable={isHumanTranscriptionAvailable}
                isAITranscriptionAvailable={isAITranscriptionAvailable}
              />
            </div>
            {!isCloudSearchResults && (
              <ArrowWrapper>
                <ToggleArrow expanded={expanded} />
              </ArrowWrapper>
            )}
          </ButtonsWrapper>
        </VisiblePart>
        {expanded && (
          <Details>
            <Attendees people={people} countries={countries} showTranscripts />
            {tags.length > 0 && <Tags>{tags.map(this.renderTag)}</Tags>}
          </Details>
        )}
      </CardWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./components/organisms/AttendeeDashboard/TranscriptCard.js